<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" md="3">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Currency Name"
          v-model="record.Name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Kshs Conversion"
          v-model="record.ConversionRate"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Symbol"
          v-model="record.Symbol"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="loader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn
          v-else
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.loader = true;
      var ConversionRate = parseFloat(this.record.ConversionRate);
      this.record.ConversionRate = ConversionRate;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
  },
};
</script>